<template>
  <div style="padding: 30px 0" v-if="hunter">
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>基本信息</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="12" style="padding-left:20px">
        <p>姓名：{{ hunter.name }}</p>
      </a-col>
      <a-col>
        <p>邮箱：{{ hunter.email }}</p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>英文名：{{ hunter.name_en }}</p>
      </a-col>
      <a-col>
        <p>电话：{{ hunter.tel }}</p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>
          签约状态：
          <b style="color:#42b983" v-if="hunter.hunter.is_sign == 1">已签约</b>
          <b style="color:#e00909" v-else>未签约</b>
        </p>
      </a-col>
      <a-col>
        <p>
          合同期限：{{ hunter.contract.start_time }} —
          {{ hunter.contract.end_time }}
        </p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>所在地区：{{ hunter.province_name }}-{{ hunter.city_name }}</p>
      </a-col>
      <a-col>
        <p>最近登录时间：{{ hunter.login_at }}</p>
      </a-col>
      <a-col span="24" style="padding-left:20px">
        <p>所属猎企：{{ hunter.company }}</p>
      </a-col>
      <a-col span="24" style="padding-left:20px">
        <p>擅长行业：软件、通信/电信/网络、IT咨询</p>
      </a-col>
      <a-col span="24" style="padding-left:20px">
        <p>擅长职能：IT质量管理/测试/配置管理、公务员/公益事业/科研、写作/采编/出版/印刷</p>
      </a-col>
    </a-row>
    <!-- <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col >
        <a-row type="flex" align="middle" :gutter="15">
          <a-col><span style="height:25px;border-left:3px solid #35B5FE;"></span></a-col>
          <a-col><b>公司信息</b></a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px"><p><b>公司名称：</b> 唯品会（中国）有限公司</p></a-col>
      <a-col span="24" style="padding-left:20px"><p><b>公司虚名：</b> 国内一家比较牛叉叉的XXX公司</p></a-col>
      <a-col span="24" style="padding-left:20px"><p><b>所属行业：</b> 金融-保险</p></a-col>
      <a-col span="24" style="padding-left:20px"><p><b>公司规模：</b> 10000人以上</p></a-col>
    </a-row>-->
  </div>
</template>

<script>
export default {
  name: "Company",
  props: ["hunter"]
};
</script>
